<template>
  <BasicModal
    :title="title"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-body disp-scroll">
      <div class="-bottom-8px" style="display: flex;">
        <p class="-right-8px"><b>インポート内容</b></p>
        <b-upload v-model="csvFile" accept=".csv">
          <a class="button is-small">
            <b-icon icon="upload"></b-icon>
            <span>インポートするファイルを選択</span>
          </a>
        </b-upload>
      </div>
      <p class="desc">CSVはカンマ区切りでA列に名前、B列に部門名を入れてください。</p>
      <table>
        <tr>
          <th class="table-th">名前</th>
          <th class="table-th">郵便番号</th>
          <th class="table-th">都道府県</th>
          <th class="table-th">市町村</th>
          <th class="table-th">番地など</th>
          <th class="table-th">説明</th>
          <th class="table-th">操作</th>
        </tr>
        <tr v-for="(d, idx) in importData" :key="idx">
          <td class="table-td grandchild" v-if="d.grandchild">
            <span class="mdi mdi-subdirectory-arrow-right" style="font-size: 16px; margin-left: 24px"></span>
            <textarea class="textarea is-small" maxlength="100" v-model="d.name"></textarea>
          </td>
          <td class="table-td child" v-else-if="d.child">
            <span class="mdi mdi-subdirectory-arrow-right" style="font-size: 16px; margin-left: 8px"></span>
            <textarea class="textarea is-small" maxlength="100" v-model="d.name"></textarea>
          </td>
          <td class="table-td parent" v-else>
            <textarea class="textarea is-small" maxlength="100" v-model="d.name"></textarea>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="100" v-model="d.postal_code"></textarea>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="100" v-model="d.region"></textarea>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="100" v-model="d.locality"></textarea>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="100" v-model="d.street"></textarea>
          </td>
          <td class="table-td">
            <textarea class="textarea is-small" maxlength="100" v-model="d.description"></textarea>
          </td>
          <td class="table-td">
            <div style="display: flex;">
              <button
              @click="addRecord(idx, 'parent')"
              class="button is-small is-primary -left-8px">追加</button>
              <button
              class="button is-small -left-8px"
              disabled
              v-if="d.grandchild">子組織を追加</button>
              <button
              @click="addRecord(idx, 'grandchild')"
              class="button is-small -left-8px"
              v-else-if="d.child">子組織を追加</button>
              <button
              @click="addRecord(idx, 'child')"
              class="button is-small -left-8px"
              v-else>子組織を追加</button>
              <button
              @click="delRecord(idx)"
              class="button is-small is-danger -left-8px -right-8px">削除</button>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="bulkCreateDepartment()" :disabled="importData.length === 0 || isLoadingModal">
        <template v-if="!isLoadingModal">作成する</template>
        <template v-else><span class="mdi mdi-loading mdi-spin"></span>作成中です</template>
      </button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import Encoding from 'encoding-japanese'
export default {
  name: 'ModalImportDepartment',
  componentName: 'ModalImportDepartment',
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      require: true
    },
    isLoadingModal: {
      type: Boolean,
      require: true
    }
  },
  data () {
    return {
      title: '部門のCSVインポート',
      importData: [],
      csvFile: null,
      confirmDesc: '既に追加済みのデータがある場合、それを上書きして反映いたしますがよろしいでしょうか？'
    }
  },
  watch: {
    csvFile () {
      if (this.csvFile) {
        this.csvFileImport()
      }
    },
    isShowModal () {
      if (!this.isShowModal) {
        this.importData = []
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('changeModal', false)
    },
    bulkCreateDepartment () {
      if (confirm(this.confirmDesc)) {
        this.$emit('bulkCreateDepartment', this.importData)
      }
    },
    // インポートデータ 項目追加
    addRecord (idx, data) {
      if (this.importData.length > 3000) {
        alert('追加の上限値に達しました。')
        return
      }
      let childFlg = false
      let grandchildFlg = false
      // 親組織
      if (data == "parent") {
        childFlg = false
        grandchildFlg = false
      // 子組織
      } else if (data == "child") {
        childFlg = true
        grandchildFlg = false
      // 孫組織
      } else {
        childFlg = false
        grandchildFlg = true
      }
      this.importData.splice(idx + 1, 0, {
        name       : '',
        postal_code : '',
        region: '',
        locality: '',
        street: '',
        description: '',
        child      : childFlg,
        grandchild : grandchildFlg
      })
    },
    // インポートデータ 項目削除
    delRecord (idx) {
      if (this.importData.length === 1) {
        alert('これ以上削除することはできません。')
        return
      }
      this.importData.splice(idx, 1)
    },
    // CSV インポート（検索用）
    csvFileImport () {
      let reader = new FileReader()
      reader.onload = (e) => {
        const res = new Uint8Array(e.target.result)
        const encoding = Encoding.detect(res)
        const data = Encoding.convert(res, {
          to: 'unicode',
          from: encoding,
          type: 'string'
        })
        const arr = data.trim().replace(/\"/g, "").split("\n").map(v => v.split(","))
        let insertArr = []
        let isError = false
        let isParent = false
        let isChild = false
        for (let i in arr) {
          if (arr[i] === '' || (arr[i].length !== 6 && arr[i].length !== 12 && arr[i].length !== 18)) {
          // if (arr[i] === '' || (arr[i].length !== 2 && arr[i].length !== 4 && arr[i].length !== 6)) {
            isError = true
            continue
          }
          let param = {
            name: '',
            postal_code: '',
            region: '',
            locality: '',
            street: '',
            description: '',
            child: false,
          }
          if (arr[i][0] !== '') {
            // 親組織処理中
            isParent = true
            isChild = false
          }
          else if (arr[i][0] === '' && arr[i][1] === '' && arr[i][2] === '' && arr[i][3] === '' && arr[i][4] === '' && arr[i][5] === '' && arr[i][6] !== '') {
          // else if (arr[i][0] === '' && arr[i][1] === '' && arr[i][2] !== '') {
            if (isParent === false) {
              // 子組織なのに親組織が無い
              isChild = false
              isError = true
              continue
            }
            // 子組織処理中
            isChild = true
          }
          else if (arr[i][0] === '' && arr[i][1] === '' && arr[i][2] === '' && arr[i][3] === '' && arr[i][4] === '' && arr[i][5] === '' && arr[i][6] === '' && arr[i][7] === '' && arr[i][8] === '' && arr[i][9] === '' && arr[i][10] === '' && arr[i][11] === '' && arr[i][12] !== '') {
          // else if (arr[i][0] === '' && arr[i][1] === '' && arr[i][2] === '' && arr[i][3] === '' && arr[i][4] !== '') {
            if (isParent === false || isChild === false) {
              // 孫組織なのに親組織または子組織が無い
              isError = true
              continue
            }
            // 孫組織処理中
          }
          for (let j in arr[i]) {
            switch (Number(j)) {
              case 0:
                param.name = arr[i][j]
                break
              case 1:
                param.postal_code = arr[i][j]
                break
              case 2:
                param.region = arr[i][j]
                break
              case 3:
                param.locality = arr[i][j]
                break
              case 4:
                param.street = arr[i][j]
                break
              case 5:
                param.description = arr[i][j]
                break
              case 6:
                if (arr[i][j] != "") {
                  param.name = arr[i][j]
                  param.child = true
                }
                break
              case 7:
                if (arr[i][j] != "") {
                  param.postal_code = arr[i][j]
                  param.child = true
                }
                break
              case 8:
                if (arr[i][j] != "") {
                  param.region = arr[i][j]
                  param.child = true
                }
                break
              case 9:
                if (arr[i][j] != "") {
                  param.locality = arr[i][j]
                  param.child = true
                }
                break
              case 10:
                if (arr[i][j] != "") {
                  param.street = arr[i][j]
                  param.child = true
                }
                break
              case 11:
                if (arr[i][j] != "") {
                  param.description = arr[i][j]
                  param.child = true
                }
                break
              case 12:
                if (arr[i][j] != "") {
                  param.name = arr[i][j]
                  param.child = false
                  param.grandchild = true
                }
                break
              case 13:
                if (arr[i][j] != "") {
                  param.postal_code = arr[i][j]
                  param.child = false
                  param.grandchild = true
                }
                break
              case 14:
                if (arr[i][j] != "") {
                  param.region = arr[i][j]
                  param.child = false
                  param.grandchild = true
                }
                break
              case 15:
                if (arr[i][j] != "") {
                  param.locality = arr[i][j]
                  param.child = false
                  param.grandchild = true
                }
                break
              case 16:
                if (arr[i][j] != "") {
                  param.street = arr[i][j]
                  param.child = false
                  param.grandchild = true
                }
                break
              case 17:
                if (arr[i][j] != "") {
                  param.description = arr[i][j]
                  param.child = false
                  param.grandchild = true
                }
                break
            }
          }
          insertArr.push(param)
        }
        if (insertArr.length > 0) {
          if (isError === true) {
            alert('一部読み込めない組織データがありました。')
          }
          this.importData = insertArr
        } else {
          alert('正しく挿入できませんでした。')
        }
        this.csvFile = null
      }
      reader.readAsArrayBuffer(this.csvFile)
    },
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  height: 500px;
  padding: 24px;
  justify-content: space-between;
}
.desc {
  font-size: smaller;
  color: #666;
  text-align: left;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  input {
    min-height: 36px;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
  textarea {
    min-height: 36px;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
}
.grandchild {
  textarea {
    min-height: 36px;
    min-width: calc(100% - 48px);
    float: right;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: calc(100% - 48px);
  }
}
.child {
  textarea {
    min-height: 36px;
    min-width: calc(100% - 32px);
    float: right;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: calc(100% - 32px);
  } 
}
.parent {
  textarea {
    min-height: 36px;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
}
.table-th {
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/ModalImportDepartment.vue